
import { Component, Vue, Prop } from 'vue-property-decorator'
import { Customer } from '@/models'

@Component({
  name: 'CustomersHeaderClassic'
})
export default class extends Vue {
  @Prop({ required: true }) private filteredCustomers!: number
  @Prop({ required: true }) private hasResults!: boolean
  @Prop({ required: true }) private exporting!: boolean
  private totalCustomers = 0

  async created(): Promise<void> {
    await this.getCustomers()
  }

  private async getCustomers(): Promise<void> {
    const { meta } = await Customer.stats({ total: 'count' }).all()
    this.totalCustomers = meta.stats.total.count
  }

  handleExportCommand(command: string) {
    if (command === 'excel') {
      this.$emit('export')
    } else if (command === 'csv') {
      this.$emit('exportCSV')
    }
  }

  handleExport() {
    // Implementation of handleExport method
  }
}
